import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sub-page',
  templateUrl: './sub-page.component.html',
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class SubPageComponent {
  @Input() title?: string = null;
  @Input() backRoute?: string | string[] = null;
  @Input() class?: string = null;

  constructor(private router: Router) {}

  goBack(): void {
    if (this.backRoute) {
      const route = Array.isArray(this.backRoute)
        ? this.backRoute
        : [this.backRoute];
      this.router.navigate(route);
    }
  }
}
